var _require = require('./overlay.shell'),
  buildRustscriptOverlay = _require.buildRustscriptOverlay;
var _require2 = require('./import-dropzone'),
  dropzoneMarkup = _require2.dropzoneMarkup;
module.exports = {
  idleOverlay: function idleOverlay() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? '' : _ref$error;
    var errorBlock = error ? "<p class=\"rs-import-error\" role=\"alert\">".concat(error, "</p>") : "<p class=\"rs-import-error\" hidden role=\"alert\"></p>";
    return buildRustscriptOverlay({
      className: 'rs-overlay-modal rs-import-overlay rs-import-script-overlay',
      title: 'Import Saved Script',
      titleClass: 'rs-overlay-title-hero',
      bodyHtml: "\n        ".concat(dropzoneMarkup({
        id: 'rs-import-script-drop-zone',
        ariaLabel: 'Import saved script file',
        lead: 'Drag and drop a script file here',
        clickHint: 'or click to choose a file'
      }), "\n\n        ").concat(errorBlock, "\n      ")
    });
  },
  loadingOverlay: function loadingOverlay() {
    return buildRustscriptOverlay({
      className: 'rs-overlay-modal rs-overlay-status rs-import-overlay rs-import-script-overlay rs-import-loading',
      title: 'Loading script…',
      titleClass: 'rs-overlay-title-loading',
      bodyHtml: "\n        <div class=\"rs-publish-spinner\" aria-hidden=\"true\">\n          <span class=\"rs-publish-spinner-box\"></span>\n          <span class=\"rs-publish-spinner-box\"></span>\n          <span class=\"rs-publish-spinner-box\"></span>\n          <span class=\"rs-publish-spinner-box\"></span>\n        </div>\n        <p class=\"rs-overlay-lead rs-import-loading-lead\">Processing your saved script.</p>\n      "
    });
  }
};